import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300); // Wait for fade-out animation
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  const getToastStyles = () => {
    const baseStyles = `fixed bottom-4 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg transition-all duration-300 max-w-md ${
      visible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
    }`;

    switch (type) {
      case 'success':
        return `${baseStyles} bg-brand-50 border border-brand-200 text-brand-800`;
      case 'error':
        return `${baseStyles} bg-rose-50 border border-rose-200 text-rose-800`;
      case 'warning':
        return `${baseStyles} bg-amber-50 border border-amber-200 text-amber-800`;
      case 'info':
        return `${baseStyles} bg-slate-50 border border-slate-200 text-slate-800`;
      default:
        return `${baseStyles} bg-gray-50 border border-gray-200 text-gray-800`;
    }
  };

  const getIcon = () => {
    const iconProps = { size: 20 };
    switch (type) {
      case 'success':
        return <CheckCircle {...iconProps} className="text-brand-500" />;
      case 'error':
        return <XCircle {...iconProps} className="text-rose-500" />;
      case 'warning':
        return <AlertCircle {...iconProps} className="text-amber-500" />;
      case 'info':
        return <AlertCircle {...iconProps} className="text-slate-500" />;
      default:
        return <CheckCircle {...iconProps} className="text-gray-500" />;
    }
  };

  return (
    <div className={getToastStyles()}>
      {getIcon()}
      <span className="flex-1 text-sm font-medium">{message}</span>
      <button
        onClick={handleClose}
        className="ml-2 text-gray-400 hover:text-gray-600 transition-colors"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default Toast;
